import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import React from 'react';
import { usePopoverContext } from './context.js';
import { themed } from '@indeed/ifl-css';
import { jsx } from '@emotion/react';
import { Divider } from '../Divider/Divider.js';
import '@indeed/ihl-use-id';
import '../../hooks/useResponsiveValue.js';
import '../../hooks/useBreakpointIndex.js';
import '../../utils/warnDeprecation.js';
import '../../utils/warn.js';
import '../VisuallyHidden/VisuallyHidden.js';

const TitleText = /*#__PURE__*/themed("h2", process.env.NODE_ENV === "production" ? {
  styleProps: [],
  target: "e1ldemxw0"
} : {
  styleProps: [],
  target: "e1ldemxw0",
  label: "TitleText"
})(() => ({
  boxSizing: "border-box",
  marginBlockStart: 0,
  marginBlockEnd: 0,
  marginInlineStart: 0,
  marginInlineEnd: 0,
  color: "foreground.strong",
  minInlineSize: 0,
  paddingBlockEnd: 2,
  fontWeight: "bold",
  variant: "text.level3"
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

/**
 * PopoverTitle
 *
 * @deprecated The `Popover` component will be removed in IFL 7.
 * See the IFL 7 preparation guide for more information: https://link.indeed.tech/ifl-7-prep-guide
 **/
const PopoverTitle = props => {
  const {
    isMobile,
    usePopoverTitle
  } = usePopoverContext();
  const id = usePopoverTitle();
  return jsx(React.Fragment, null, jsx(TitleText, _extends({
    id: id
  }, props)), isMobile ? jsx(Divider, {
    sx: {
      marginInlineStart: -5,
      marginInlineEnd: -5,
      marginBlockStart: 0,
      marginBlockEnd: 2,
      inlineSize: _ref => {
        let {
          space
        } = _ref;
        return `calc(100% + 2*${space[5]})`;
      }
    }
  }) : null);
};
PopoverTitle.displayName = "PopoverTitle";

export { PopoverTitle };
